import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/[locale]/labs/page.tsx");
